export default __webpack_public_path__ + "static/media/blogging.fda5d2c9.png";